import moment from 'moment';

export const formattedDate = (dateString) => {
    if (!dateString) {
        return '';
    }
    return moment(dateString).format('DD/MM/YYYY');
};



// WEBPACK FOOTER //
// ./src/utils/date-utils.js